import React from 'react';
import { cn } from '@lib/utils.ts';

type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  text?: string;
  variant?: 'fullWidth' | 'inset';
  className?: string;
};

export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  text,
  variant = 'fullWidth',
  className,
}) => {
  return orientation === 'horizontal' ? (
    <div className={cn('flex items-center w-full', className)}>
      <div
        className={cn(
          'flex-1 bg-[#CECECE] origin-top',
          variant === 'inset' ? 'ml-4' : ''
        )}
        style={{
          height: '1px',
          transform: 'scaleY(0.5)',
        }}
      />
      {text && <span className="mx-2 text-gray-500">{text}</span>}
      <div
        className={cn(
          'flex-1 bg-[#CECECE] origin-top',
          variant === 'inset' ? 'ml-4' : ''
        )}
        style={{
          height: '1px',
          transform: 'scaleY(0.5)',
        }}
      />
    </div>
  ) : (
    <div className={cn('h-full flex items-center', className)}>
      <div className="border-l border-[#CECECE] h-full" />
    </div>
  );
};
